export default __webpack_public_path__ + "static/media/attendance-green-tick-active.79783a06.svg";